<div class="m-4" *ngIf="eventScheduleNotFound">
  <h2>Schedule not found</h2>
</div>

<div class="m-4" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="m-4" *ngIf="!eventScheduleNotFound && (serverError === null)">

  <div class="form-group">
    <label for="nameInput">Staff Schedule Name (optional)</label>
    <input type="text" class="form-control"
           id="nameInput"
           name="name"
           [(ngModel)]="schedule.name">
    <small class="form-text text-muted">This name is only used to organize the list of schedules. It is not displayed to customers.</small>
    <div class="form-text text-danger">
      {{ errors.name }}
    </div>
  </div>

  <div class="form-group">
    <label for="customer_facing_name">Customer Schedule Name (optional)</label>
    <input type="text" class="form-control"
           id="customer_facing_name"
           name="customer_facing_name"
           [(ngModel)]="schedule.customer_facing_name">
    <small class="form-text text-muted">This is displayed in the Climber App for events created from this schedule. It is shown after the event type name to help customers distinguish between schedules of the same event type. </small>
    <div class="form-text text-danger">
      {{ errors.customer_facing_name }}
    </div>
  </div>

  <div class="form-group" *ngIf="eventType?.schedule_type === ScheduleType.rolling">
    <label for="roster">Roster</label>
    <select class="custom-select"
            id="roster" name="roster"
            [(ngModel)]="schedule.roster_id"
            (ngModelChange)="setLocationToRosterDefault()"
            [disabled]="loadingSchedule || loadingRosters || !isNewSchedule"
            [class.disabled]="loadingSchedule || loadingRosters || !isNewSchedule">
      <option *ngIf="loadingSchedule || loadingRosters">Loading...</option>
      <ng-container *ngIf="!(loadingSchedule || loadingRosters)">
        <option [ngValue]="null" disabled>---</option>
        <option *ngFor="let roster of rosters"
                [ngValue]="roster.id">
          {{ roster.name }}
        </option>
      </ng-container>
    </select>
    <div class="form-text text-danger">{{ errors.roster_id }}</div>
  </div>

  <div class="row">
    <div class="col">
      <div class="form-group">
        <label for="selectLocation">Location</label>
        <select class="custom-select"
                id="selectLocation" name="selectLocation"
                [(ngModel)]="schedule.location_id"
                [disabled]="loadingSchedule || !isNewSchedule"
                [class.disabled]="loadingSchedule || !isNewSchedule">
          <ng-container *ngIf="locations">
            <option *ngFor="let location of locations"
                    [ngValue]="location.id">
              {{ location.name }}
              <ng-container *ngIf="(eventType?.schedule_type === ScheduleType.rolling) && (selectedRosterLocationId === location.id)">
                (Roster location)
              </ng-container>
            </option>
          </ng-container>
        </select>
        <small *ngIf="eventType.has_limited_location_availability"
               class="form-text text-muted">
          This event type is restricted to specific locations.
        </small>
        <div class="form-text text-danger">{{ errors.location_id }}</div>
      </div>
    </div>
    <div class="col">
      <div class="form-group">
        <ng-container *ngIf="loadingSchedule || loadingLocationAreas">
          <label>Area</label>
          <a class="float-right" routerLink="/areas-config" target="_blank">
            Configure Areas
          </a>
          <select class="custom-select" disabled>
            <option>Loading...</option>
          </select>
        </ng-container>
        <ng-container *ngIf="!(loadingSchedule || loadingLocationAreas)">
          <label for="locationAreaSelect">
            Area
          </label>
          <div class="float-right">
            <a href="#"
               (click)="$event.preventDefault();loadLocationAreas();">
              Refresh Areas
            </a>
            |
            <a routerLink="/areas-config" target="_blank">
              Configure Areas
            </a>
          </div>
          <select class="custom-select" id="locationAreaSelect" name="gym_area_id"
                  [(ngModel)]="schedule.location_area_id">
            <option [ngValue]="null">No Area</option>
            <option *ngFor="let locationArea of getLocationAreasForLocation()" [ngValue]="locationArea.id">
              {{ locationArea.name }} (Capacity {{ locationArea.capacity }})
            </option>
          </select>
        </ng-container>
        <small class="form-text text-muted clearfix">
          Setting an area will cap capacity for individual events once the area's capacity has been met. This is optional, and capacity may also be set per time slot.
        </small>
        <div class="form-text text-danger">{{ errors.location_area_id }}</div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <div class="form-group">
        <label for="startDate">Start Date</label>
        <app-date-picker [id]="'startDate'"
                         [(content)]="schedule.start_date"></app-date-picker>
        <div class="form-text text-danger">
          {{ errors.start_date }}
        </div>
      </div>
    </div>
    <div class="col">
      <div class="form-group">
        <label for="endDate">End Date (optional)</label>
        <app-date-picker [id]="'endDate'"
                         [(content)]="schedule.end_date"></app-date-picker>
        <div class="form-text text-danger">
          {{ errors.end_date }}
        </div>
      </div>
    </div>
  </div>

  <div class="form-group">
    <label for="rollingDays">
      <ng-container *ngIf="eventType?.schedule_type !== ScheduleType.rolling">
        How far in advance can someone book this event?
      </ng-container>
      <ng-container *ngIf="eventType?.schedule_type === ScheduleType.rolling">
        How far in advance should events be created for this schedule?
      </ng-container>
    </label>
    <div class="row">
      <div class="col-6">
        <div class="input-group">
          <input type="number" class="form-control"
                 name="rollingDays"
                 id="rollingDays"
                 min="1" max="90" step="1"
                 [(ngModel)]="schedule.rolling_days">
          <div class="input-group-append">
            <span class="input-group-text">days</span>
          </div>
        </div>
      </div>
    </div>
    <div class="form-text text-danger">
      {{ errors.rolling_days }}
    </div>
  </div>

  <div class="form-group" *ngIf="eventType?.schedule_type !== ScheduleType.rolling">
    <label for="booking_open_time">
      At what time of day does booking open for this event?
    </label>
    <div class="row">
      <div class="col-6">
        <div class="input-group">
          <input type="time" class="form-control"
                 name="booking_open_time"
                 id="booking_open_time"
                 [(ngModel)]="schedule.booking_open_time">
        </div>
      </div>
    </div>
    <small class="form-text text-muted">
      Use this setting to determine at what time of day (in the location's local time) this event first becomes available for booking. The default, midnight ("00:00", or "12 AM"), is counted as the <i>start</i> of the day.
    </small>
    <div class="form-text text-danger">
      {{ errors.booking_open_time }}
    </div>
  </div>

  <div class="form-group" *ngIf="eventType?.schedule_type !== ScheduleType.rolling">
    <label>Capacity per Time Slot</label>
    <div class="row">
      <div class="col-6">
        <input type="number" class="form-control" name="capacity"
               min="1" max="1000" step="1"
               [(ngModel)]="schedule.capacity">
      </div>
    </div>
    <div class="form-text text-danger">
      {{ errors.capacity }}
    </div>
  </div>

  <ng-container *ngIf="eventType?.schedule_type !== ScheduleType.rolling">

    <div class="form-group">
      <label>Pricing Matrix</label>
      <div class="row">
        <div class="col-6">
          <select class="custom-select" name="pricing_matrix_id"
                  [(ngModel)]="schedule.pricing_matrix_id">
            <option [ngValue]="null" class="text-muted">None</option>
            <option *ngFor="let pricingMatrix of pricingMatrices"
                    [ngValue]="pricingMatrix.id">
              {{ pricingMatrix.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="form-text text-danger">
        {{ errors.pricing_matrix_id }}
      </div>
    </div>

    <div class="form-group">
      <div class="row">
        <div class="col-sm-8 col-lg-6">
          <label for="tax_rate_id">Tax Rate</label>
          <div class="float-right">
            <a href="#"
               (click)="$event.preventDefault();loadTaxRates();">
              Refresh Tax Rates
            </a>
            |
            <a routerLink="/tax-rates-config" target="_blank">
              Configure Tax Rates
            </a>
          </div>
          <select class="custom-select"
                  name="tax_rate_id" id="tax_rate_id"
                  *ngIf="!loadingTaxRates"
                  [(ngModel)]="schedule.tax_rate_id">
            <option [ngValue]="null">
              Event Type Default ({{ getEventTypeTaxRate() }})
            </option>
            <option *ngFor="let taxRate of taxRateList"
                    [ngValue]="taxRate.id">
              {{ taxRate.name }} - {{ taxRate.rate_percent }}%
            </option>
          </select>
          <select class="custom-select"
                  *ngIf="loadingTaxRates" disabled>
            <option>Loading...</option>
          </select>
        </div>
      </div>
    </div>

  </ng-container>

  <ng-container *ngIf="eventType?.schedule_type === ScheduleType.repeating">
    <div class="row">
      <div class="col-sm-6">
        <div class="form-group">
          <ng-container *ngIf="loadingSchedule || loadingBenefitMemberships">
            <label>Benefit Membership (optional)</label>
            <select class="custom-select" disabled>
              <option>Loading...</option>
            </select>
          </ng-container>
          <ng-container *ngIf="!(loadingSchedule || loadingBenefitMemberships)">
            <label for="benefit_membership_id">
              Benefit Membership (optional)
            </label>
            <div class="float-right">
              <a href="#"
                 (click)="$event.preventDefault();loadBenefitMemberships();">
                Refresh Memberships
              </a>
              |
              <a routerLink="/memberships-and-passes" target="_blank">
                Configure Memberships
              </a>
            </div>
            <select class="custom-select"
                    id="benefit_membership_id"
                    name="benefit_membership_id"
                    [(ngModel)]="schedule.benefit_membership_id">
              <option [ngValue]="null">No Benefit Membership</option>
              <option *ngIf="benefitMembershipRetired(schedule.benefit_membership_id)"
                      [ngValue]="schedule.benefit_membership_id">
                {{ schedule.benefit_membership_name }} (Retired)
              </option>
              <option *ngFor="let membership of benefitMembershipList"
                      [ngValue]="membership.id">
                {{ membership.name }}
              </option>
            </select>
          </ng-container>
          <small class="form-text text-muted clearfix">
            Each participant booked onto a session from this schedule receives the benefit membership from the beginning of the session's day through the end of that day, plus the additional days. Participants already booked onto upcoming sessions receive it when the schedule is saved; sessions that have already started are not changed.
            <br>
            Only active memberships with Purchase Type "Benefit" may be selected.
          </small>
          <div class="form-text text-danger">{{ errors.benefit_membership_id }}</div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="form-group">
          <label for="benefit_membership_additional_days">
            Benefit Additional Days After Event
          </label>
          <div class="input-group">
            <input type="number" class="form-control"
                   name="benefit_membership_additional_days"
                   id="benefit_membership_additional_days"
                   min="0" max="365" step="1"
                   [disabled]="schedule.benefit_membership_id === null"
                   [(ngModel)]="schedule.benefit_membership_additional_days">
            <div class="input-group-append">
              <span class="input-group-text">days</span>
            </div>
          </div>
          <small class="form-text text-muted">
            The number of additional days after the event that the benefit membership should extend. For example, with 13 additional days, a session on 5 October grants the membership through the end of 18 October.
          </small>
          <div class="form-text text-danger">{{ errors.benefit_membership_additional_days }}</div>
        </div>
      </div>
    </div>
  </ng-container>

  <div class="form-group">
    <label>Duration (minutes)</label>
    <div class="row">
      <div class="col-6">
        <input type="number" class="form-control" name="duration_minutes"
               min="1" max="1440" step="1"
               [(ngModel)]="schedule.duration_minutes">
      </div>
    </div>
    <div class="form-text text-danger">
      {{ errors.duration_minutes }}
    </div>
  </div>

  <div class="form-group">
    <label for="repetition">Repetition</label>
    <div class="row">
      <div class="col-6">
        <select class="custom-select"
                name="repetition" id="repetition"
                [(ngModel)]="schedule.repetition">
          <option [ngValue]="EventScheduleRepetition.weekly">Weekly</option>
          <option [ngValue]="EventScheduleRepetition.biweekly">Every other week</option>
          <option [ngValue]="EventScheduleRepetition.monthlyFirstDays">Monthly, first selected day(s) of month</option>
          <option [ngValue]="EventScheduleRepetition.monthlySecondDays">Monthly, second selected day(s) of month</option>
          <option [ngValue]="EventScheduleRepetition.monthlyThirdDays">Monthly, third selected day(s) of month</option>
          <option [ngValue]="EventScheduleRepetition.monthlyFourthDays">Monthly, fourth selected day(s) of month</option>
          <option [ngValue]="EventScheduleRepetition.monthlyLastDays">Monthly, last selected day(s) of month</option>
        </select>
      </div>
    </div>
    <small class="form-text text-muted">
      When set to "Weekly", the configured time slots will apply each week. For "Every other week", the first week of events is defined as the 7 days beginning with the configured start date. The "Monthly" options allow the time slots to only apply on certain weeks of the month. For example, if a schedule has time slots on Wednesday and Friday, and has its repetition set to "Monthly, second selected day(s) of month", the schedule will have events on the second Wednesday and second Friday of each month.
    </small>
    <div class="form-text text-danger">
      {{ errors.repetition }}
    </div>
  </div>

  <div class="alert alert-info"
       *ngIf="(schedule.repetition === EventScheduleRepetition.biweekly) && schedule.start_date">
    The first week of events is the 7-day period beginning
    {{ dayOfWeekStringFromISO8601(schedule.start_date) }}, {{ dateStringFromISO8601(schedule.start_date) }}.
    Events are held on alternating weeks thereafter. In order to change which week events are held, update the start date.
  </div>

  <div class="form-group">
    <div class="row">
      <div class="col-xl-6 col-lg-8 col-md-10 col-12">
        <app-edit-event-instructors [instructors]="schedule.instructor_details"
                                    [useIsSub]="false"
                                    [id]="'editInstructors'"></app-edit-event-instructors>
      </div>
    </div>
    <small class="form-text text-muted">
      Assigning instructors here will make them the default instructors for this schedule.  In the event you need to make a one-off modification (e.g., an instructor is on vacation), go to Scheduled Events and make the change directly on the event.
    </small>
    <div class="form-text text-danger">
      {{ errors.instructor_ids }}
    </div>
  </div>

  <b>Reservation Time Slots</b>

  <div class="ml-3 mt-2 mb-3">

    <div *ngFor="let timeSlot of eventTimeSlots">

      <div class="form-group">
        <div class="row">
          <div class="col-6">
            <label>Start Time</label>
            <input type="time" step="60"
                   class="form-control" name="startTime"
                   [(ngModel)]="timeSlot.start_time">
          </div>
          <div class="col-6">
            <button class="btn btn-danger btn-sm float-right"
                    (click)="removeTimeSlot(timeSlot)">
              Remove Time Slot
            </button>
          </div>
        </div>
        <div class="form-text text-danger" *ngIf="eventTimeSlotsErrors[timeSlot.id]">
          {{ eventTimeSlotsErrors[timeSlot.id].start_time }}
        </div>
      </div>

      <div class="form-group">
        <label>Days Available</label>
        <br>
        <button class="btn mr-2 day-button"
                [class.btn-outline-secondary]="!timeSlot.is_available_sunday"
                [class.btn-primary]="timeSlot.is_available_sunday"
                (click)="timeSlot.is_available_sunday = !timeSlot.is_available_sunday">
          S
        </button>
        <button class="btn mr-2 day-button"
                [class.btn-outline-secondary]="!timeSlot.is_available_monday"
                [class.btn-primary]="timeSlot.is_available_monday"
                (click)="timeSlot.is_available_monday = !timeSlot.is_available_monday">
          M
        </button>
        <button class="btn mr-2 day-button"
                [class.btn-outline-secondary]="!timeSlot.is_available_tuesday"
                [class.btn-primary]="timeSlot.is_available_tuesday"
                (click)="timeSlot.is_available_tuesday = !timeSlot.is_available_tuesday">
          T
        </button>
        <button class="btn mr-2 day-button"
                [class.btn-outline-secondary]="!timeSlot.is_available_wednesday"
                [class.btn-primary]="timeSlot.is_available_wednesday"
                (click)="timeSlot.is_available_wednesday = !timeSlot.is_available_wednesday">
          W
        </button>
        <button class="btn mr-2 day-button"
                [class.btn-outline-secondary]="!timeSlot.is_available_thursday"
                [class.btn-primary]="timeSlot.is_available_thursday"
                (click)="timeSlot.is_available_thursday = !timeSlot.is_available_thursday">
          T
        </button>
        <button class="btn mr-2 day-button"
                [class.btn-outline-secondary]="!timeSlot.is_available_friday"
                [class.btn-primary]="timeSlot.is_available_friday"
                (click)="timeSlot.is_available_friday = !timeSlot.is_available_friday">
          F
        </button>
        <button class="btn mr-2 day-button"
                [class.btn-outline-secondary]="!timeSlot.is_available_saturday"
                [class.btn-primary]="timeSlot.is_available_saturday"
                (click)="timeSlot.is_available_saturday = !timeSlot.is_available_saturday">
          S
        </button>
        <br>
        <button class="btn btn-link btn-sm pl-0"
                *ngIf="!allDaysAreAvailable(timeSlot)"
                (click)="setAllDaysAvailability(timeSlot, true)">
          Select All
        </button>
        <button class="btn btn-link btn-sm pl-0"
                *ngIf="allDaysAreAvailable(timeSlot)"
                (click)="setAllDaysAvailability(timeSlot, false)">
          Deselect All
        </button>
      </div>

      <div class="alert alert-danger" role="alert"
           *ngIf="eventTimeSlotsErrors[timeSlot.id] && eventTimeSlotsErrors[timeSlot.id].non_field_errors">
        {{ eventTimeSlotsErrors[timeSlot.id].non_field_errors }}
      </div>
      <div class="alert alert-danger" role="alert"
           *ngIf="eventTimeSlotsErrorMessage[timeSlot.id]">
        {{ eventTimeSlotsErrorMessage[timeSlot.id] }}
      </div>

      <hr>

    </div>

    <button class="btn btn-link btn-sm pl-0" (click)="addNewTimeSlot()">
      + Add New Time Slot
    </button>

  </div>

  <div class="alert alert-danger" role="alert"
       *ngIf="errors.non_field_errors">
    {{ errors.non_field_errors }}
  </div>
  <div class="alert alert-danger" role="alert"
       *ngIf="errorMessage">
    {{ errorMessage }}
  </div>

  <div class="alert alert-info" role="alert"
       *ngIf="loadingSave">
    Saving...
  </div>

  <button class="btn btn-primary float-right"
          [disabled]="isLoading()" [class.disabled]="isLoading()"
          (click)="save()">
    Save Schedule
  </button>

  <a class="btn btn-secondary"
          [routerLink]="'/events/setup/edit/' + eventType?.id + '/schedules'">
    Cancel
  </a>

</div>
